module.exports = __webpack_public_path__ + "img/picture_dtjq.33423b38.png";